import { Moon, Sun } from 'lucide-react';
import { usePostHog } from 'posthog-js/react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/use-theme';

export function ModeToggle() {
  const { theme, setTheme } = useTheme();
  const posthog = usePostHog();

  const toggle = (e: React.MouseEvent<HTMLButtonElement>) => {
    const nextTheme = theme === 'dark' ? 'light' : 'dark';
    posthog.capture('theme_toggled', { from: theme, to: nextTheme });
    const rect = e.currentTarget.getBoundingClientRect();
    setTheme(nextTheme, { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 });
  };

  return (
    <Button variant="outline" size="icon" onClick={toggle} aria-label="Toggle theme">
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  );
}
